import { Box } from "@mui/material";
import React from "react";
import useCurrentBusinessInfo from "../../hooks/useCurrentBusiness";

// ——— Netflix-ish tokens (design only)
const COLORS = {
  bg: "#0b0b0b",
  panel: "#141414",
  text: "#ffffff",
  muted: "rgba(255,255,255,0.78)",
  border: "rgba(255,255,255,0.12)",
  red: "#E50914",
};

const CoverImage = () => {
  const { currentBusiness } = useCurrentBusinessInfo();
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: 360, md: 440 },
        width: "100%",
        overflow: "hidden",
      }}
    >
      {/* Banner Image */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${
            currentBusiness?.cover_image ??
            "https://images.unsplash.com/photo-1557683316-973673baf926?q=80&w=2400&auto=format&fit=crop"
          })`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "saturate(1.05) contrast(1.02)",
          transform: "scale(1.02)",
        }}
      />

      {/* Cinematic overlays */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.55) 55%, rgba(11,11,11,1) 100%)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(1200px 500px at 10% 20%, rgba(229,9,20,0.12), transparent 60%)",
          pointerEvents: "none",
        }}
      />
    </Box>
  );
};

export default CoverImage;
